import { useEffect, useState } from 'react'
import { apiEtapa6 } from '../api'
import Aviso from '../../components/Aviso'
import { Campo, dataBR } from '../../etapa2/componentes'

const SITUACAO = { OK: 'OK', PENDENTE: 'Pendente', ATENCAO: 'Atenção' }

export default function ViradaAno() {
  const [ano, setAno] = useState(String(new Date().getFullYear() + 1))
  const [dados, setDados] = useState(null)
  const [erro, setErro] = useState('')

  useEffect(() => {
    if (ano.length !== 4) return
    setErro('')
    apiEtapa6.viradaAno(ano).then(setDados).catch((e) => { setDados(null); setErro(e.message) })
  }, [ano])

  return (
    <section>
      <h2>Virada do ano</h2>
      <p className="fundamento">
        O que precisa estar publicado em parametros_legais_globais para calcular o ano. Sem a versão do ano, a folha usa a do ano
        anterior e avisa em cada cálculo. Os feriados nacionais e bancários são calculados automaticamente.
      </p>
      <div className="grade"><Campo rotulo="Ano"><input type="number" value={ano} onChange={(e) => setAno(e.target.value)} /></Campo></div>
      <Aviso>{erro}</Aviso>
      {dados && (
        <>
          <table>
            <thead><tr><th>Item</th><th>Situação</th><th>Detalhe</th></tr></thead>
            <tbody>
              {dados.itens.map((i) => (
                <tr key={i.item + i.detalhe} className={`situacao-${i.situacao.toLowerCase()}`}>
                  <td>{i.item}</td><td><strong>{SITUACAO[i.situacao]}</strong></td><td>{i.detalhe}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h3>Feriados de {dados.ano}</h3>
          <table>
            <thead><tr><th>Data</th><th>Feriado</th><th>Tipo</th></tr></thead>
            <tbody>
              {Object.entries(dados.feriados_bancarios).map(([d, n]) => (
                <tr key={d}><td>{dataBR(d)}</td><td>{n}</td><td>{dados.feriados_nacionais[d] ? 'Nacional' : 'Só bancário'}</td></tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  )
}
